export default "__VITE_ASSET__Tb9Rk1pK__"